import { UPDATE_BOT_HANDLER } from "./actions";

export const updateBotHandler = (payload: 'BOT' | 'AGENT') => ({
  type: UPDATE_BOT_HANDLER,
  payload
});
